if (!customElements.get('natunora-navigation')) {
  customElements.define('natunora-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const trigger = this.querySelector('[data-menu-open]');
      const dialog = this.querySelector('dialog');
      const desktop = window.matchMedia('(min-width: 990px)');
      const header = this.closest('.natunora-header');
      const observeHero = () => {
        this.heroObserver?.disconnect();
        const hero = document.querySelector('.natunora-home-hero');
        header.removeAttribute('data-over-hero');
        if (!hero) return;
        const height = header.offsetHeight;
        header.toggleAttribute('data-over-hero', hero.getBoundingClientRect().bottom > height);
        this.heroObserver = new IntersectionObserver(([entry]) => {
          header.toggleAttribute('data-over-hero', entry.isIntersecting);
        }, { rootMargin: `-${height}px 0px 0px 0px` });
        this.heroObserver.observe(hero);
      };
      this.headerObserver?.disconnect();
      this.headerObserver = new ResizeObserver(observeHero);
      this.headerObserver.observe(header);
      document.addEventListener('shopify:section:load', observeHero, options);
      observeHero();
      desktop.addEventListener('change', () => {
        if (desktop.matches && dialog.open) dialog.close();
      }, options);
      trigger.addEventListener('click', (event) => {
        dialog.toggleAttribute('data-pointer-open', event.detail > 0);
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelector('[data-menu-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('keydown', () => dialog.removeAttribute('data-pointer-open'), options);
      dialog.addEventListener('close', () => trigger.setAttribute('aria-expanded', 'false'), options);
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
        if (event.target.closest('a')) dialog.close();
      }, options);
    }

    disconnectedCallback() {
      this.querySelector('dialog')?.close();
      this.controller?.abort();
      this.heroObserver?.disconnect();
      this.headerObserver?.disconnect();
    }
  });
}
